export default __webpack_public_path__ + "static/media/clipboard-check-solid.d197318e.svg";